import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  MailboxCreate,
  Mailbox,
  MailboxUserCreate,
  MailboxUser,
  MailboxUserUpdate,
  MailboxData,
  MailboxUsersData,
} from '../../shared/models/mailbox.models';

@Injectable({
  providedIn: 'root',
})
export class MailboxService {
  private http = inject(HttpClient);

  createMailbox(data: MailboxCreate): Observable<Mailbox> {
    return this.http.post<Mailbox>('/mailbox/mailboxes', data);
  }

  createMailboxUser(data: MailboxUserCreate): Observable<MailboxUser> {
    return this.http.post<MailboxUser>(`/mailbox/mailboxes/${data.mailboxId}/users`, data);
  }

  updateMailboxUser(id: number, data: MailboxUserUpdate): Observable<void> {
    return this.http.patch<void>(`/mailbox/users/${id}`, data);
  }

  deleteMailbox(id: number): Observable<void> {
    return this.http.delete<void>(`/mailbox/mailboxes/${id}`);
  }

  deleteMailboxUser(id: number): Observable<void> {
    return this.http.delete<void>(`/mailbox/users/${id}`);
  }

  searchMailbox(page = 1, search?: string): Observable<[Mailbox[], number]> {
    let url = `/mailbox/mailboxes?page=${page}`;
    if (search) url = `${url}&search=${search}`;

    return this.http.get<[Mailbox[], number]>(url);
  }

  toggleMailbox(id: number): Observable<void> {
    return this.http.patch<void>(`/mailbox/mailboxes/${id}/toggle`, {});
  }

  toggleMailboxUser(id: number, enable = true): Observable<void> {
    return this.http.patch<void>(`/mailbox/users/${id}/toggle`, { enable });
  }

  getOneById(id: number): Observable<Mailbox> {
    return this.http.get<Mailbox>(`/mailbox/mailboxes/${id}`);
  }

  syncQuotas(serverId: string): Observable<void> {
    return this.http.patch<void>(`/mailbox/mailboxes/servers/${serverId}/quotas/update`, {});
  }

  getWebsiteMailbox(websiteId: number): Observable<MailboxData> {
    return this.http.get<MailboxData>(`/backend-for-frontend/mailbox?websiteId=${websiteId}`);
  }

  getMailboxUsers({
    query,
    skip,
    take,
  }: {
    query?: string;
    skip?: number;
    take?: number;
  }): Observable<MailboxUsersData> {
    const params = new URLSearchParams();

    if (query !== undefined) {
      params.set('query', query);
    }

    if (skip !== undefined) {
      params.set('skip', String(skip));
    }

    if (take !== undefined) {
      params.set('take', String(take));
    }

    return this.http.get<MailboxUsersData>(
      `/backend-for-frontend/mailbox/users?${params.toString()}`,
    );
  }
}
